import api from './client';

export interface QaDevice {
  device_id: string;
  last_ip: string | null;
  granted_at: string;
  expires_at: string;
  force_offer_disabled: number;
}

export interface QaSettings {
  settings: Record<string, string>;
  ip: string;
  devices: QaDevice[];
}

// QA settings have their own endpoint (not /admin/settings) so the page needs
// only the `qa` section permission and stays editable for read-only admins.
export async function getQaSettings(): Promise<QaSettings> {
  return api.get<QaSettings>('/admin/qa');
}

export async function updateQaSettings(data: Record<string, string>): Promise<Record<string, string>> {
  return api.put<Record<string, string>>('/admin/qa', data);
}

export async function revokeQaDevice(deviceId: string): Promise<{ device_id: string }> {
  return api.delete<{ device_id: string }>(`/admin/qa/devices/${encodeURIComponent(deviceId)}`);
}

export async function grantQaDevice(data: {
  device_id: string;
  ttl_hours: number;
  force_offer_disabled: boolean;
}): Promise<QaDevice> {
  return api.post<QaDevice>('/admin/qa/devices', data);
}

export async function updateQaDevice(
  deviceId: string,
  forceOfferDisabled: boolean,
): Promise<QaDevice> {
  return api.patch<QaDevice>(`/admin/qa/devices/${encodeURIComponent(deviceId)}`, {
    force_offer_disabled: forceOfferDisabled,
  });
}
